import Axios from 'axios';
export default {

  createCMFactoresExcel(model)
  {
    //let query = `model=` + model;
    return Axios.post(`conveniomarco/CreateCMFactoresExcel/`,model);

  },
  getProductosCMClienteOptimizado(paging,search) {
    let query = paging + `&search=` + search;
    return Axios.get(`conveniomarco/GetProductosClientesOptimizado/?${query}`);

},
  getProductosCMCliente()
  {
   return Axios.get(`conveniomarco/GetProductosClientes`);
  },
  getEvolucionProductoCliente(idcmproducto)
  {
    let query = `idcmproducto=` + idcmproducto;     
   return Axios.get(`conveniomarco/GetEvolucionProductoCliente/?${query}`);
  },
   async avisosProductosCMExcel() {

    const response = await Axios({
      url: `conveniomarco/AvisosProductosCMExcel`,
      method: 'GET',
      responseType: 'blob',
    });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', "ProductosCM" + ".xlsx"); // or any other extension
    document.body.appendChild(link);
    link.click();
  },
   async getCMFactoresExcel() {

    const response = await Axios({
      url: `conveniomarco/GetCMFactoresExcel`,
      method: 'GET',
      responseType: 'blob',
    });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', "CMFactores" + ".xlsx"); // or any other extension
    document.body.appendChild(link);
    link.click();
  }
}